import type { ReactNode } from 'react'

import { t } from '../../../common/i18n.js'
import type { Language } from '../../../common/types/i18n.js'
import { Calendar, Home, MoreHorizontal, PartyPopper, Users } from '../icon/solar-icons.js'
import { Link } from '../link/link.js'
import './portal-bottom-nav.css'

interface NavItem {
    path: string
    label: (lang: Language) => string
    icon: ReactNode
}

export interface PortalBottomNavProps {
    activePath: string | null
    lang: Language
    onMoreClick: () => void
}

const items: NavItem[] = [
    {
        path: '/',
        label: (l) => t.portal.nav.dashboard(l),
        icon: <Home size={20} weight="BoldDuotone" />,
    },
    {
        path: '/calendar',
        label: (l) => t.portal.nav.calendar(l),
        icon: <Calendar size={20} weight="BoldDuotone" />,
    },
    {
        path: '/people',
        label: (l) => t.portal.nav.people(l),
        icon: <Users size={20} weight="BoldDuotone" />,
    },
    {
        path: '/events',
        label: (l) => t.portal.nav.events(l),
        icon: <PartyPopper size={20} weight="BoldDuotone" />,
    },
]

export const PortalBottomNav = ({ activePath, lang, onMoreClick }: PortalBottomNavProps) => (
    <nav className="portal-bottom-nav" aria-label={t.common.mobileNavigation(lang)}>
        {items.map((item) => (
            <Link
                key={item.path}
                href={item.path}
                className="portal-bottom-nav__item"
                isActive={activePath === item.path}
            >
                <span className="portal-bottom-nav__icon">{item.icon}</span>
                <span className="portal-bottom-nav__label">{item.label(lang)}</span>
            </Link>
        ))}
        <button type="button" className="portal-bottom-nav__item" onClick={onMoreClick}>
            <span className="portal-bottom-nav__icon">
                <MoreHorizontal size={20} weight="BoldDuotone" />
            </span>
            <span className="portal-bottom-nav__label">{t.portal.nav.more(lang)}</span>
        </button>
    </nav>
)
